<template>
  <div class="layer mobilityPreset">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"><span class="blind">close</span></button>
      <div class="layerTitle toCapitalize">{{ locale.mobility_destination_preset }}</div>
      <div class="presetList">
        <div class="presetItemBox">
          <div
            v-for="(item, index) in preset"
            :key="index"
            class="presetItem"
            @click.stop="apply(item)">
            <div class="presetItemInner">
              <div v-if="item.img" class="img"><img :src="item.img" alt=""></div>
              <div class="title">{{ item.title[ln] }}</div>
              <div v-if="item.description[ln]" class="description">{{ item.description[ln] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DestinationPreset',
  props: [
    'locale',
    'ln',
    'preset'
  ],
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    apply (item) {
      const data = {
        name: item.name,
        address: item.placeInfo.shortFormattedAddress || item.placeInfo.formattedAddress,
        location: item.placeInfo.location,
        presetId: item.id
      }
      this.$emit('apply', data)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 780px;
    padding: 30px;
  }
}
.presetItem{
  cursor: pointer;
}
</style>
